import * as S from './VisualWorking.styled';

const VisualWorking = () => {
  return (
    <>
      <S.Wrap>
        <S.Figure />
        <S.Text>
          대출비교 서비스가 <br />
          준비 중이에요.
        </S.Text>
        <S.SubText>가능한 빠른 시일 내에 찾아뵙겠습니다.</S.SubText>
      </S.Wrap>
    </>
  );
};

export default VisualWorking;
